import countries from "./countries.json";
import { equalsIgnoreCase,  } from "./Util";

export const GetCountryName = (countryCode, language) => {
    const country = countries.find(c => equalsIgnoreCase(countryCode, c.countryCode))
    const countryName = country[language.toUpperCase()]
    return countryName ?? countryCode
};

export const GetCountries = (language) => {

    return countries.map(c => {
        return {
            countryCode: c.countryCode,
            countryName: c[language]
        }
    })
}